import { render, staticRenderFns } from "./mailbox.vue?vue&type=template&id=21c92a12&"
import script from "./mailbox.vue?vue&type=script&lang=js&"
export * from "./mailbox.vue?vue&type=script&lang=js&"
import style0 from "./mailbox.vue?vue&type=style&index=0&id=21c92a12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports